import {
  API_ERROR,
  LOGIN_SUCCESS,
  LOGIN_USER,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
} from "./actionTypes";

const initialState = {
  authUser: null,      // <-- Add this line
  error: "",
  loading: false,
  isUserLogout: false,
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        authUser: action.payload, // <-- Save user here
        error: "",
      };

    case LOGOUT_USER:
      return {
        ...state,
        isUserLogout: false,
        loading: true,
      };

    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        isUserLogout: true,
        loading: false,
        authUser: null,  // <-- Clear user data on logout
        error: "",
      };

    case API_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default login;
